/**
 * Full-page navigation for marketing flows that leave the SPA (Stripe
 * Checkout, or the app after signup). Kept in its own module so tests can
 * mock it; jsdom can't spy on `window.location.assign`.
 */
export function redirectTo(url: string): void {
  window.location.assign(url);
}
